export default "__VITE_ASSET__BMIJtiza__"